<template>

<core-content-wrapper :empty="!hindexScore && is.ready" :loading="!is.ready || is.refreshing" :isBuilding="isBuilding">

	<core-content-empty v-if="!hindexScore && is.ready && !is.refreshing" title="Oh dear, no plays!" text="You are yet to start your H-index journey." />

	<core-filter :loading="is.fetching" :filter="insightName" v-on:refresh="onRefresh" :subtitle="subtitle">

		<template v-if="hasIndexes">

			<core-button theme="filter" text="Edit index" tooltip="Edit or remove index" :icon-left="$isMobile" :icon-only="$isDesktop" icon="pencil" v-on:click.native="onEditClick" v-if="canEdit" />

			<core-button theme="filter" text="About index" tooltip="About index" :icon-left="$isMobile" :icon-only="$isDesktop" icon="info" v-on:click.native="onEditClick" v-if="!canEdit" />

			<core-button theme="filter" text="Create index" tooltip="Create new index" :icon-left="$isMobile" :icon-only="$isDesktop" icon="plus" v-on:click.native="onCreateClick" v-if="isSelf" />

			<core-button theme="filter" text="Community indexes" tooltip="Browse community indexes" :icon-left="$isMobile" :icon-only="$isDesktop" icon="magnifying-glass" v-on:click.native="onBrowseClick" v-if="isSelf" />

		</template>

	</core-filter>

	<core-content-page v-if="is.reset && is.fetching !== 'all'">

		<template v-if="hindexScore">

			<core-content-page-inner v-show="is.ready" :is-grid="true">

				<com-head :fetching="is.fetching" :your="your" :you="you" :size="3" />
				<com-overview :fetching="is.fetching" :your="your" :you="you" :size="3" />

				<com-tabs :tabs="tabs" :active="tab" v-on:change="onTabChange" />

			</core-content-page-inner>

			<core-content-page-inner v-show="is.ready" :is-grid="true" class="tab-content">

				<template v-if="tab === 'games'">

					<com-games :fetching="is.fetching" :your="your" :you="you" :size="6" />
					<com-latecomers :fetching="is.fetching" :your="your" :you="you" :size="6" />
					<com-near :fetching="is.fetching" :your="your" :you="you" :size="6" />
					<com-past :fetching="is.fetching" :your="your" :you="you" :size="6" />
					<com-next :fetching="is.fetching" :your="your" :you="you" :size="6" />

				</template>

				<template v-if="tab === 'ladder'">

					<com-levels :fetching="is.fetching" :your="your" :you="you" :size="6" />

				</template>

				<template v-if="tab === 'traits'">

					<com-weight :fetching="is.fetching" :your="your" :you="you" :size="3" />
					<com-counts :fetching="is.fetching" :your="your" :you="you" :size="3" />
					<com-duration :fetching="is.fetching" :your="your" :you="you" :size="3" />
					<com-ratings :fetching="is.fetching" :your="your" :you="you" :size="3" />
					<com-designers :fetching="is.fetching" :your="your" :you="you" :size="2" />
					<com-publishers :fetching="is.fetching" :your="your" :you="you" :size="2" />
					<com-types :fetching="is.fetching" :your="your" :you="you" :size="2" />

				</template>

				<template v-if="tab === 'community'">

					<com-peers :fetching="is.fetching" :your="your" :you="you" :size="3" />
					<com-share :fetching="is.fetching" :your="your" :you="you" :size="3" />
					<com-plays :fetching="is.fetching" :your="your" :you="you" :size="6" />
					<com-concentration :fetching="is.fetching" :your="your" :you="you" :size="3" />
					<com-bias :fetching="is.fetching" :your="your" :you="you" :size="3" />
					<com-efficiency :fetching="is.fetching" :your="your" :you="you" :size="3" />
					<com-coverage :fetching="is.fetching" :your="your" :you="you" :size="3" />

				</template>

			</core-content-page-inner>

		</template>

	</core-content-page>

</core-content-wrapper>

</template>

<script>

import Section from './common/Section.js'

import comNext from './hindex/Next'
import comPeers from './hindex/Peers'
import comPast from './hindex/Past'
import comLatecomers from './hindex/Latecomers'
import comNear from './hindex/Near'
import comPlays from './hindex/Plays'
import comRatings from './hindex/Ratings'
import comHead from './hindex/Head'
import comOverview from './hindex/Overview'
import comDuration from './hindex/Duration'
import comCounts from './hindex/Counts'
import comWeight from './hindex/Weight'
import comLevels from './hindex/Levels'
import comGames from './hindex/Games'
import comTabs from './common/Tabs'
import comDesigners from './hindex/Designers'
import comPublishers from './hindex/Publishers'
import comTypes from './hindex/Types'
import comConcentration from './hindex/Concentration'
import comBias from './hindex/Bias'
import comEfficiency from './hindex/Efficiency'
import comShare from './hindex/Share'
import comCoverage from './hindex/Coverage'

export default {

	mixins: [Section],

	components: {
		'com-latecomers': comLatecomers,
		'com-next': comNext,
		'com-plays': comPlays,
		'com-past': comPast,
		'com-near': comNear,
		'com-designers': comDesigners,
		'com-publishers': comPublishers,
		'com-efficiency': comEfficiency,
		'com-share': comShare,
		'com-coverage': comCoverage,
		'com-types': comTypes,
        'com-head': comHead,
        'com-overview': comOverview,
        'com-duration': comDuration,
		'com-ratings': comRatings,
        'com-counts': comCounts,
        'com-weight': comWeight,
        'com-levels': comLevels,
        'com-peers': comPeers,
		'com-games': comGames,
		'com-tabs': comTabs,
		'com-concentration': comConcentration,
		'com-bias': comBias
	},

	data: function() {

		return {

			insightName: 'hindex',
			dynamicInsights: [
				'type',
				'duration',
			],
			tab: 'games'

		}

	},

	watch: {

		index: function() {

			this.is.ready = false

			this.onRefresh()

		}

	},

	computed: {

		hindexScore: function() {

			return this.$store.getters['page/insights/hindex/levels'].length

		},

		hasIndexes: function() {

			return this.$store.getters['page/insights/hindex/indexes'].indexes

		},

		isBuilding: function() {

			return (this.$route.params.index) ? !this.$_.findWhere(this.$store.getters['context/hindex'].tracking, {
				slug: this.$route.params.index
			}).generated : false

		},

		canEdit: function() {

			if(!this.loggedin) return false

			if (this.index) {

				return this.$_.findWhere(this.$store.getters['page/insights/hindex/indexes'].indexes, {
					slug: this.$route.params.index
				}).user === this.$store.getters['session/user/id']

			} else {

				return false

			}

		},

		index: function() {

			return this.$route.params.index

		},

		subtitle: function() {

			return (this.$route.params.index) ? this.$_.findWhere(this.$store.getters['context/hindex'].tracking, {
				slug: this.$route.params.index
			}).name : 'H-index'

		},

		tabs: function() {

			var tabs = [
				{ value: 'games', text: 'Games' },
				{ value: 'traits', text: 'Traits' },
				{ value: 'ladder', text: 'Ladder' },
			]

			if(this.$store.getters['page/insights/hindex/public']) {

				tabs.push({ value: 'community', text: 'Peers' })

			}

			return tabs

		}

	},

	methods: {

		onCreateClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'hindexCreate'
			})

		},

		onEditClick: function() {

			var index = this.$_.findWhere(this.hasIndexes, {
				slug: this.$route.params.index || 'h-index'
			})

			this.$pubsub.$emit('open.modal', {
				id: 'hindexView',
                index: index,
				direct: true
			})

		},

		onBrowseClick: function() {

            this.$pubsub.$emit('open.modal', {
				id: 'hindexBrowse'
			})

        },

		afterLoad: function() {

			if(this.$route.params.index) {
				
				this.$_.findWhere(this.$store.getters['context/hindex'].tracking, {
					slug: this.$route.params.index
				}).generated = 1

			}
			
		},

		onTabChange: function(value) {

			this.tab = value

		}

	}

}

</script>

<style scoped>

.tab-content {
	padding-top: 40px!important;
}

.is-mobile .tab-content {
	padding-top: 0px!important;
}

.is-desktop .tab-content:before {
    position: absolute;
    content: '';
    display: block;
    left: -40px;
	right: -40px;
	top: 0px;
	bottom: -40px;
	background-color: #fff;
}

.is-desktop .tab-content >>> .insights-item:hover:before {
	background-color: #edf8ff;
}

</style>